module.exports = __webpack_public_path__ + "media/arek1.ab476e1e.mp3";